// extracted by mini-css-extract-plugin
export default {"button":"button_button__0On-O","button-primary":"button_button-primary__cVGcm","button-secondary":"button_button-secondary__MtT8-","button-link":"button_button-link__zmUgI"};